import { BaseQuote } from '../../../../common/js/quote/BaseQuote';
import { Subject } from 'rxjs';

import { AuthenticationService } from '../authentication/authentication.service';
import { Router } from '@angular/router';

export abstract class BaseQuickQuoteService {
  triggerQuickQuoteLoad: Subject<void> = new Subject<void>();

  constructor(protected authenticationService: AuthenticationService, protected router: Router) {}

  abstract getCurrentQuote(): BaseQuote;

  abstract setCustomerQuote(): void;

  /**
   *  We need to check if an Identity exists for the customer to take them to Login/Signup flow
   */
  public routeCustomer(): void {
    if (this.authenticationService.isLoggedIn()) {
      this.router.navigate(['application-form']);
    } else {
      this.authenticationService.goToAuthenticate();
    }
  }

  public loadQuickQuote(): void {
    this.triggerQuickQuoteLoad.next();
  }
}
